import React, { useState, Component } from 'react'
import { Header } from './components/Header'
import { HouseZones } from './components/HouseZones'
import { CompatibilityStatus } from './components/CompatibilityStatus'
import { ComponentSelection } from './components/ComponentSelection'
import { ZoneDetails } from './components/ZoneDetails'
import { BOMPrice } from './components/BOMPrice'
import { TCOComfort } from './components/TCOComfort'
import { Terms } from './components/Terms'
import { CTABar } from './components/CTABar'
import { Zone, Component, Configuration } from './utils/types'
import { sampleZones, sampleComponents } from './utils/data'
export function App() {
  const [showVat, setShowVat] = useState(true)
  const [selectedZone, setSelectedZone] = useState<Zone | null>(null)
  const [zones, setZones] = useState<Zone[]>(sampleZones)
  const [configuration, setConfiguration] = useState<Configuration>({
    components: [],
    totalPrice: 189500,
    monthlyPayment: 1249,
    eta: '5-7 hverdage',
  })
  const handleZoneSelect = (zone: Zone) => {
    setSelectedZone(zone)
  }
  const handleAddComponent = (
    component: Component,
    targetZone: Zone | 'all',
  ) => {
    setConfiguration((prev) => ({
      ...prev,
      components: [
        ...prev.components,
        {
          ...component,
          zone: targetZone,
        },
      ],
    }))
  }
  return (
    <div className="bg-gray-50 min-h-screen w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <Header showVat={showVat} setShowVat={setShowVat} />
        <div className="mt-8 lg:grid lg:grid-cols-3 lg:gap-8">
          <div className="lg:col-span-2">
            <HouseZones
              zones={zones}
              selectedZone={selectedZone}
              onZoneSelect={handleZoneSelect}
            />
            <ComponentSelection
              components={sampleComponents}
              zones={zones}
              onAddComponent={handleAddComponent}
            />
            {selectedZone && (
              <ZoneDetails zone={selectedZone} configuration={configuration} />
            )}
            <BOMPrice configuration={configuration} showVat={showVat} />
            <TCOComfort />
            <Terms />
          </div>
          <div className="hidden lg:block">
            <div className="sticky top-8">
              <CompatibilityStatus
                configuration={configuration}
                zones={zones}
              />
            </div>
          </div>
        </div>
        {/* Mobile compatibility status */}
        <div className="lg:hidden mt-8">
          <CompatibilityStatus configuration={configuration} zones={zones} />
        </div>
      </div>
      <CTABar configuration={configuration} showVat={showVat} />
    </div>
  )
}
